import { formatNumber } from './formatNumber';

export function getShortNumber(value) {
  if (typeof value === 'string') return value;
  if (value === -1 || value === null) return 0;
  if (value < 1000) return formatNumber(value);
  return `${Math.trunc(value / 100) / 10}k`;
}
